<template>
	<div>
<!--		<breadcrumb :routerList="[{to:'/dingd/purchaselist',title:'订单管理'},{title:'财务报表'}]"/>-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="SW订单号">
								<el-input v-model="formInline.sapCode" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="　　SAP订单号">
								<el-input v-model="formInline.add2" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="　　订单发票号">
								<el-input v-model="formInline.add4" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="　　纸质发票号">
								<el-input v-model="formInline.bktxt" placeholder="请输入"></el-input>
							</el-form-item>
						</div>
						<div class="h-thirdColumn w-newColumn">

							<el-form-item label="订单类型" prop="orderCategory">
								<brselect category="xiaoshou_quyu" :v="formInline.orderCategory"
										  v-model="formInline.orderCategory" clearable
										  :disabled="ddlxdisabled"
										  @change="changeOrderCate"
								></brselect>
							</el-form-item>
							<el-form-item label="　　订单子类型" prop="orderCategory">
								<el-select v-model="formInline.orderCategory1" clearable placeholder="请选择" style="width:100%">
									<el-option v-for="item in orderCategory1List"
											   :key="item.code"
											   :label="item.name"
											   :value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
                            <el-form-item label="开票时间" style="width: 50%;">
                                <el-date-picker
                                        placeholder="请选择"
                                        v-model="formInline.add5Begin"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                               <span class="w-time-to">至</span>
                                <el-date-picker
                                        placeholder="请选择"
                                        v-model="formInline.add5End"
                                        clearable
                                        type="date"
                                        value-format="yyyy-MM-dd" >
                                </el-date-picker>
                            </el-form-item>

						</div>
						<div class="h-thirdColumn w-newColumn">

							<el-form-item label="是否高于基准价" prop="gaobenchmark">
								<el-select v-model="formInline.gaobenchmark" :clearable="true">
									<el-option label="等于" value="1"></el-option>
									<el-option label="高于" value="2"></el-option>
									<el-option label="低于" value="3"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="特价类型" prop="gaobenchmark">
								<brselect
										clearable
										category="category_tejia"
										:v="formInline.category"
										v-model="formInline.category">
								</brselect>
							</el-form-item>
							<el-form-item label="开票类型" prop="orderCategory">
								<brselect category="fapiao_type" :v="formInline.fkart"
										  v-model="formInline.fkart" clearable
								></brselect>
							</el-form-item>

							<el-form-item label="创建时间" style="width: 50%;">
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.cdateBegin"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
								<span class="w-time-to">至</span>
								<el-date-picker
										placeholder="请选择"
										v-model="formInline.cdateEnd"
										clearable
										type="date"
										value-format="yyyy-MM-dd" >
								</el-date-picker>
							</el-form-item>

						</div>
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="" prop="gaobenchmark">
								<el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
								<el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
							</el-form-item>
						</div>
						<!--<div class="h-thirdColumn w-newColumn">-->
							<!--<el-form-item label="订单状态" prop="ddstatusList" style="width: 50%;">-->
								<!--<el-select v-model="ddstatusList"  multiple :clearable="true">-->
									<!--<el-option label="未过账" value="1"></el-option>-->
									<!--<el-option label="已过账未开票" value="2"></el-option>-->
									<!--<el-option label="已开票" value="3"></el-option>-->
								<!--</el-select>-->
							<!--</el-form-item>-->

						<!--</div>-->
					</el-form>
				</div>
			</div>
			<div class="h-row purchaselist">
				<div class="h-rowIn" style="width:100%;">
					<el-table
							ref="multipleTable"
							:data="tableData"
							stripe
							:row-style="cellstyle"
							style="width: 100%"
							:border="true"
							max-height="450"
					>
						<el-table-column
								type="index"
								width="40"
								label="#"
								fixed
						>
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="sapCode"
								label="SW订单号"
								width="120">
						</el-table-column>
						<el-table-column
                               :show-overflow-tooltip="true"
								prop="orderCategory"
								label="订单类型"
								width="110">
							<template scope="scope">
								{{scope.row.orderCategory|dictname('xiaoshou_quyu')}}
							</template>
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="orderCategory1"
								label="订单子类型"
								width="110">
							<template scope="scope">
								{{scope.row.orderCategory1|dictname('xiaoshou_quyu_nwx') }}
							</template>
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="fkart"
								label="开票类型"
								width="110">
							<template scope="scope">
								{{scope.row.fkart|dictname('fapiao_type') }}
							</template>
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="proType"
								label="自产/OEM"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="gscode"
								label="销售组织"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="soldToCode"
								label="售达方编码"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="soldToName"
								label="售达方名称"
								width="190">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="cdate"
								label="创建时间"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="add2"
								label="SAP订单号"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="add3"
								label="交货单号"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="add4"
								label="系统发票号"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="add5"
								label="开票日期"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="bktxt"
								label="纸质发票号"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="materialCode"
								label="物料编码"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="materialName"
								label="物料型号"
								width="140">
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="category"
								label="特价类型"
								width="110">
							<template slot-scope="scope" >
								{{scope.row.category|dictname('category_tejia')}}
							</template>
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="specialId"
								label="特价版本号"
								width="160">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="specialPrice"
								label="特价价格"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="tejiashuoming"
								label="特价说明"
								width="150">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="note"
								label="订单备注"
								width="150">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="chengben"
								label="BOM成本"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="proBenchmarkPrice"
								label="产品基准价"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="finalPrice"
								label="成交价"
								width="110">
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="xxx"
								label="高于基准价"
								width="110">
							<template slot-scope="scope" >
								{{scope.row.finalPrice > scope.row.proBenchmarkPrice ?"高":(scope.row.finalPrice < scope.row.proBenchmarkPrice ?"低":"等于")}}
							</template>
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="proNumber"
								label="产品数量"
								width="110">
						</el-table-column>
						<el-table-column
                                :show-overflow-tooltip="true"
								prop="totalprice"
								label="订单金额"
								width="110">
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="currencyCode"
								label="币种"
								width="80">
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="exchangermb"
								label="汇率"
								width="80">
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="totalpricermb"
								label="含税收入(RMB)"
								width="130">
						</el-table-column>
			<!--			<el-table-column
                                :show-overflow-tooltip="true"
								prop="mll"
								label="毛利率"
								width="110">
						</el-table-column>-->
						<el-table-column
								:show-overflow-tooltip="true"
								prop="maoli"
								label="毛利额"
								width="110">
							<template scope="scope">
								{{scope.row.maoli?(parseFloat(scope.row.maoli).toFixed(2)):''}}
 							</template>
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="maolilv"
								label="毛利率"
								width="110">
							<template scope="scope">
								{{scope.row.maolilv?new big(Number(scope.row.maolilv).toFixed(2)).times('100') + '%':''}}
							</template>
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="jygx"
								label="经营贡献额"
								width="110">
							<template scope="scope">
								{{scope.row.jygx?(parseFloat(scope.row.jygx).toFixed(2)):''}}
							</template>
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="jygxlv"
								label="经营贡献率"
								width="110">
							<template scope="scope">
								{{scope.row.jygxlv?new big(Number(scope.row.jygxlv).toFixed(2)).times('100') + '%':''}}
							</template>
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="lr"
								label="利润额"
								width="110">
							<template scope="scope">
								{{scope.row.lr?(parseFloat(scope.row.lr).toFixed(2)):''}}
							</template>
						</el-table-column>
						<el-table-column
								:show-overflow-tooltip="true"
								prop="lrlv"
								label="利润率"
								width="110">
							<template scope="scope">
 								{{scope.row.lrlv?new big(Number(scope.row.lrlv).toFixed(2)).times('100') + '%':''}}
							</template>
						</el-table-column>

					</el-table>
					<div class="h-tableB h-mrt30">
						<div class="h-tableBL">
							<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="downloadExcel">批量导出</el-button>
						</div>
						<div class="h-pagination2">
							<pagination :page="formInline" @query="query"/>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>
<script>
	import ss from '../../api/SystemService'
	import util from "../../utils/util"
	import updownfile from '../../utils/updownfile'
	export default {
	    filters:{
            gdjjz(v){
                if(v==0){
                    return '等于';
				}else if(v>0){
                    return '高于';
                }else if(v<0){
                    return '低于';
                }
			}
		},
		data(){
			return{
				proSupplier:{},
				checked:true,
				status:1,
				names:'',
				input1:'',
                ddstatusList:[],
				formInline:{
					ddfph:null,
					sapddh:null,
                    ddstatus:[],
					bktxt:null,
                    fkart:null,
					cdateBegin:null,
					cdateEnd:null,
					add5Begin:null,
					add5End:null,
                    orderCategory:null,
                    orderCategory1:null,
					gaobenchmark:null,
                    category:null,
					sapCode:null,
					pageSize:10,
					pageNo:1,
                    total:0,
				},
				options2:[],
				//列表
				tableData: [],
			}
		},
		created(){
            this.orderCategory1AllList=this.$store.getters.dictlist("xiaoshou_quyu_nwx");
		},
		methods:{
			//表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//检索按钮功能
			checkData(){
				this.formInline.pageNo = 1;
				this.query();
			},
            changeOrderCate(cate){
                if(cate){
                    this.orderCategory1List =  _.filter(this.orderCategory1AllList,{pid:cate.id});
                }else{
                    this.orderCategory1List =  [];
                }

            },
			//重置按钮功能
			resetData(){
				this.formInline.ddfph=null;
				this.formInline.sapddh=null;
				this.formInline.sapCode=null;
				this.formInline.bktxt=null;
				this.formInline.fkart=null;
				this.formInline.gaobenchmark=null;
				this.formInline.orderCategory=null;
				this.formInline.orderCategory1=null;
				this.formInline.cdateBegin=null;
				this.formInline.cdateEnd=null;
				this.formInline.add5Begin=null;
				this.formInline.add5End=null;
				this.formInline.category=null;
			},
			query() {
                this.formInline.ddstatus=_.join(this.ddstatusList,",");
				ss.orderCgService.selectPageForFinance2(this.formInline).then(rd => {
					this.formInline.total = rd.total;
					this.tableData = rd.records;
				});
			},
			//明细导出
			downloadExcel(){
                var form = _.clone(this.formInline);
                form.ddstatus=_.join(this.ddstatusList,",");
				updownfile.down("/api/swyl/v1/demo/viewOrderCaiwubbTwo/downloadExcel", form, 'post');
			},
		},
		mounted() {
			this.query();
		}
	}
</script>
<style>
	.wuliu .h-dialogForm .h-elformWrap-2 .el-form-item__label{
		width: 27%;
	}
	.wuliu .h-formbLine .h-elformWrap-2{
		width: 100%!important;
	}
	.purchaselist	.h-tableLink{
		padding:0px!important;
	}
</style>
<style scoped lang="scss">
	.bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
	.leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0.8rem;
			left: 0;
			width: 6rem;
			height: 11.5rem;
		}
		.step2{
			top: 1.63rem;
			right: 6.9rem;
			width: 9.4rem;
			height: 1.9rem;
		}
		.step3{
			width: 2.3rem;
			height: 1.9rem;
			right: 3.7rem;
			top: 1.6rem;
		}
		.step4{
			width: 3rem;
			height: 2.3rem;
			right: 0.7rem;
			top: 1.65rem;
		}
		.step5{
			width: 6.25rem;
			height: 1.3rem;
			right: 0.37rem;
			top: 4.25rem;
		}
		.step6{
			width: 3.9rem;
			height: 1.1rem;
			left: 2.6rem;
			top: 7.1rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
	}
</style>
